import type { EmbeddingOptions } from '@epilot/journey-embed-sdk'

import { env } from './env'

/**
 * Reads Vite env vars and returns `EmbeddingOptions` tailored to the current
 * environment. Shared by the CDN entry points (`src/sdk-entry.ts`,
 * `src/browser/browser.ts`) and Storybook stories so they all resolve to the
 * same dev/staging/prod URLs.
 *
 * The SDK package itself is env-agnostic: it defaults `baseUrl` to the
 * public production URL unless a caller overrides it.
 */
export const getSdkOptionsFromEnv = (): EmbeddingOptions => {
  const baseUrl = env('VITE_JOURNEY_APP_BASE_URL')
  const embedUrl = env('VITE_EMBED_URL')
  // Only honour VITE_EMBED_URL in local dev (when it points to localhost).
  // Deployed builds derive the script URL from baseUrl + channel inside the SDK.
  const webComponentScriptUrl =
    embedUrl && new URL(embedUrl).hostname === 'localhost' ? embedUrl : undefined

  return { baseUrl, webComponentScriptUrl }
}
